import { render, staticRenderFns } from "./CmsIntegrityEducate.vue?vue&type=template&id=ca4868b6&scoped=true&"
import script from "./CmsIntegrityEducate.vue?vue&type=script&lang=js&"
export * from "./CmsIntegrityEducate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4868b6",
  null
  
)

export default component.exports